/**
 * md-card-scrub.js — MoDigital (Manto de Respeito)
 * Prévia de galeria no card de produto: mover o mouse horizontalmente sobre a
 * imagem percorre as fotos do produto em sequência (spec do tema de referência).
 * Implementação original: lazy-fetch de /products/{handle}.js no primeiro hover,
 * pré-carga das imagens e troca por faixas de posição do cursor.
 */
(function () {
  'use strict';
  var CACHE = {};
  var MAX_IMAGES = 8;

  function sized(src, w) {
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function handleFrom(url) {
    var m = (url || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function initCard(media) {
    if (media.mdScrubInit) return;
    media.mdScrubInit = true;

    var link = media.querySelector('a[data-pr-url]');
    var handle = link && handleFrom(link.getAttribute('href'));
    if (!handle) return;

    if (!CACHE[handle]) {
      CACHE[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }

    CACHE[handle].then(function (product) {
      if (!product || !product.images || product.images.length < 2) return;
      var imgs = product.images.slice(0, MAX_IMAGES);

      imgs.forEach(function (src) { (new Image()).src = sized(src, 720); });

      var overlay = document.createElement('img');
      overlay.className = 'md-scrub-overlay';
      overlay.alt = '';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.style.cssText =
        'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;' +
        'opacity:0;pointer-events:none;z-index:3;';
      media.appendChild(overlay);

      var lastIdx = -1;

      media.addEventListener('mousemove', function (ev) {
        var r = media.getBoundingClientRect();
        if (!r.width) return;
        var x = Math.min(Math.max(ev.clientX - r.left, 0), r.width - 1);
        var idx = Math.floor((x / r.width) * imgs.length);
        if (idx !== lastIdx) {
          lastIdx = idx;
          overlay.src = sized(imgs[idx], 720);
          overlay.style.opacity = '1';
        }
      });

      media.addEventListener('mouseleave', function () {
        overlay.style.opacity = '0';
        lastIdx = -1;
      });
    });
  }

  document.addEventListener('mouseover', function (e) {
    if (!e.target || !e.target.closest) return;
    var media = e.target.closest('.hdt-card-product__media');
    if (media) initCard(media);
  }, { passive: true });
})();
